import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  LinearProgress,
} from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useFetch } from "../../../../hooks/Fetching";
import AppointmentSingleRevisionStatic from "./AppointmentSingleRevisionStatic";
import { cancelButtonVariant } from "../../../../components/buttons/ConfirmAndCancelButtons";
export default function AppointmentSingleRevisionDetails({
  revisionId,
  date,
  creator,
  modificator,
  action,
}) {
  const { id: appointmentId } = useParams();
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const otherData = { date, creator, modificator, action };

  const fetch = useFetch(
    `/appointment/history/revision/${appointmentId}/${revisionId}`,
    null,
    "revision_history_key" + appointmentId + revisionId,
    open
  ); // Use the url in the fetch hook

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Button
        variant="outlined"
        color="info"
        onClick={handleClickOpen}
        size="small"
        sx={{ mt: 1 }}
      >
        {t("Details")}
      </Button>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth={"md"}>
        <DialogTitle>{t("AppointmentRevisionTimestamp")}</DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText>
            {fetch.isLoading ? (
              <LinearProgress />
            ) : (
              <AppointmentSingleRevisionStatic
                data={fetch?.data}
                otherData={otherData}
              />
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="error" variant={cancelButtonVariant} sx={{mr:"3%"}}>
            {t("Close")}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
